import Column from "@components/column";
import React from "react";
import AttributeForm from "./form";
import AttributeList from "./list";

const AttributeSetup = () => {
  return (
    <Column>
      <AttributeForm />
      <AttributeList />
    </Column>
  );
};

export default AttributeSetup;
